<template>
  <fieldset class="range-wrapper">
    <input ref="sliderRef" type="range" min="0" :max="max" :value="modelValue" :step="step" list="tickmarks" @input="handleSlideChange" />
    <slot v-if="withTicks" name="ticks" />
  </fieldset>
</template>

<script lang="ts" setup>
const props = defineProps({
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 10,
  },
  step: {
    type: Number,
    default: 1,
  },
  withTicks: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Number,
    default: 5,
  },
})

const emit = defineEmits(['update:modelValue'])

const sliderRef = ref<HTMLInputElement | null>(null)

watch(() => props.modelValue, updateSlideValue)

onMounted(() => {
  updateSlideValue(props.modelValue)
})

function handleSlideChange(event: Event) {
  const target = event.target as HTMLInputElement
  const targetValue = parseFloat(target.value)
  const min = parseFloat(target.min)
  const value = Math.max(min, targetValue)

  emit('update:modelValue', value)
  _updateSliderBackground(target, targetValue)
}

function updateSlideValue(targetValue: number) {
  const slider = sliderRef.value as HTMLInputElement
  const min = parseFloat(slider.min)
  const value = Math.max(min, targetValue)

  emit('update:modelValue', value)
  _updateSliderBackground(slider, targetValue)
  slider.value = targetValue.toString()
}

function _updateSliderBackground(slider: HTMLInputElement, value: number) {
  const min = parseFloat(slider.min)
  const max = parseFloat(slider.max)
  const percentage = _calculateSliderPercentage(value, min, max)

  slider.style.background = `linear-gradient(to right, #3F808C 0%, #3F808C ${percentage}%, #747474 ${percentage}%, #747474 100%)`
}

function _calculateSliderPercentage(value: number, min: number, max: number) {
  return ((value - min) / (max - min)) * 100
}
</script>

<style lang="stylus" scoped>
.range-wrapper
  width 100%

input[type='range']
  width 100%
  height 4px
  outline none
  margin 0
  position relative
  border-radius 50px
  appearance none
  -webkit-appearance none
  background linear-gradient(to right, #3F808C 0%, #3F808C 50%, #fff 50%, #fff 100%)
  transition background 450ms ease-in

  &::-webkit-slider-thumb
    -webkit-appearance none
    appearance none
    width 16px
    height 16px
    background #fff
    border-radius 50%
    cursor pointer
    box-shadow 0px 2px 4px rgba(0, 0, 0, 0.10)
    border 1px solid rgba(0, 0, 0, 0.10)

  &::-moz-range-thumb
    width 16px
    height 16px
    background #fff
    border-radius 50%
    cursor pointer
</style>
